module.exports = __webpack_public_path__ + "img/4317b45.jpg";